import React from "react";
import "../styles/resume.css";

const Resume = props => (
  <main style={{ ...props.style }}>
    <div className="sub-section resume">
      <header>
        <hgroup>
          <h1>Ben Bright</h1>
          <h2>Full-stack Developer</h2>
        </hgroup>
        <section className="contact">
          <p>Birmingham, AL</p>
          <p>btbright@[googlemail]</p>
          <p>
            <a
              target="_blank"
              href="/files/Ben-Bright-Full-Stack-Engineer-2019.pdf"
            >
              PDF Version
            </a>
          </p>
        </section>
      </header>
      <section>
        <h1>Experience</h1>
        <div>
          <hgroup>
            <h1>
              Freelance <span>/</span>{" "}
              <span>Software Engineer &amp; Consultant</span>
            </h1>
            <h2>September 2015 - Present, Birmingham, AL</h2>
          </hgroup>
          <p>
            Designed and developed the AWS back-end and cross-platform apps for
            a pre-launch digital security startup
          </p>
          <ul>
            <li>
              Honed project goals, priorities, and requirements with CEO and
              senior stakeholders
            </li>
            <li>
              Architected AWS infrastructure and wrote core API Lambda
              JavaScript functions and Step Functions triggered by events from
              API Gateway, S3, and SQS. Used DynamoDB and S3 as data stores
            </li>
            <li>
              Abstracted infrastructure (50+ Lambda functions, 5+ Step
              Functions, and more) into scripted (Python/troposphere)
              CloudFormation templates for redeployment
            </li>
            <li>
              Refactored admin system form components and improved bootstrap
              implementation (Vue/CoreUI)
            </li>
            <li>
              Built secure enrollment process for iOS and Android apps using
              Xamarin framework. Included state issued ID processing, data entry
              screens, validated biometric capture, credentials management, and
              role-based authorization
            </li>
            <li>Prototyped liveness detection with iOS AVFoundation API</li>
            <li>Participated in regular, Slack-based scrum meetings</li>
          </ul>
          <p>
            Developed a{" "}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.section508.gov/"
            >
              Section 508
            </a>{" "}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.integramanagedcare.com/"
            >
              consumer site
            </a>{" "}
            for Integra Managed Care
          </p>
          <ul>
            <li>
              Collaborated with a designer and the client to determine
              requirements and process for meeting tight deadline
            </li>
            <li>
              Built the site using JAMStack architecture: React,
              styled-components, Gatsby, NetlifyCMS, Netlify
            </li>
            <li>
              Wrote thorough handoff documentation and led handoff process to
              client’s IT team and content stakeholders
            </li>
          </ul>
          <p>
            Refactored{" "}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.vivahealth.com/"
            >
              Viva Health
            </a>
            ’s provider and formulary databases and designed and implemented the
            ETL process to populate the formulary database for use by consumer
            facing sites
          </p>
          <ul>
            <li>
              Evaluated and documented existing stored procedures used to import
              provider and formulary data (MSSQL)
            </li>
            <li>
              Wrote new stored procedures that consolidated existing stored
              procedures and eliminated import errors
            </li>
            <li>
              Wrote console app (C#) to import upstream formulary data to
              database from standardized Word documents
            </li>
          </ul>
        </div>
        <div>
          <hgroup>
            <h1>
              Cummings Creative Group <span>/</span>{" "}
              <span>Senior Software Engineer</span>
            </h1>
            <h2>April 2013 - December 2014, Birmingham, AL</h2>
          </hgroup>
          <p>Led development of major projects including work for:</p>
          <p>
            <a
              href="https://www.motionindustries.com/"
              rel="noopener noreferrer"
              target="_blank"
            >
              Motion Industries
            </a>
            : worked directly with client stakeholders to build suite of blogs
            targeted at industrial parts buyers with a unified CMS
          </p>
          <ul>
            <li>
              Wrote cross-browser HTML, CSS, and JavaScript for users in
              environments with high Internet Explorer usage
            </li>
            <li>
              Built custom CMS integrated with client’s infrastructure (Java and
              DB2) with approval from their compliance team
            </li>
          </ul>
          <p>
            Event Operations Group: designed and developed a web-based workflow
            for their previously excel-based system that managed thousands of
            event security employees
          </p>
          <ul>
            <li>
              Met regularly with CEO and senior management to determine
              requirements and review progress
            </li>
            <li>
              Practiced deep listening to push past solutions offered by the
              client to get to deeper needs and offered solutions more suitable
              for software
            </li>
            <li>
              Implemented offline-first, stand-alone web app (HTML5, JavaScript)
              to manage event employee positions, time-in / time-out, and
              payouts
            </li>
          </ul>
          <p>
            <a
              href="https://www.vivahealth.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Viva Health
            </a>
            : core developer on enrollment systems and customer facing sites
          </p>
          <ul>
            <li>
              Architected and maintained web-based, HIPPA compliant enrollment
              system for use during open enrollment period
            </li>
            <li>
              Worked with designer to implement style guide and front-end
              component system for use across VIVA properties
            </li>
            <li>
              Developed iOS app (Xamarin) used by potential customers to
              determine an appropriate health plan
            </li>
          </ul>
        </div>
        <div>
          <hgroup>
            <h1>
              Intermark Group <span>/</span> <span>Software Engineer</span>
            </h1>
            <h2>October 2011 - April 2013, Birmingham, AL</h2>
          </hgroup>
          <ul>
            <li>
              Developed and maintained Southeast Toyota’s highly trafficked{" "}
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://southeast.buyatoyota.com/"
              >
                consumer site
              </a>{" "}
              and dealer-facing systems (.NET, C#)
            </li>
            <li>
              Automated image processing with a configurable console app to save
              days of manual work by BA every month
            </li>
            <li>
              Led development of lead processing on Southeast Toyota’s “Buy a
              Toyota” site
            </li>
            <li>
              Led development of secure, credit application lead review site for
              dealers
            </li>
            <li>
              Resolved hundreds of bugs ranging from missing inventory, pricing
              issues, UX issues, etc.
            </li>
            <li>
              Participated in sprint commit, sprint review, daily scrum
              meetings, and code review (in-person and GitHub based)
            </li>
          </ul>
        </div>
      </section>
      <section>
        <h1>Projects</h1>
        <div>
          <hgroup>
            <h1>
              Code G ACA Exemption Tool <span>/</span> <span>Co-creator</span>
            </h1>
            <h2>August 2017 - Present, Birmingham, AL</h2>
          </hgroup>
          <ul>
            <li>
              Collaborated with a tax expert to design and develop{" "}
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://btbright.github.io/code-g/"
              >
                a tool
              </a>{" "}
              (React SPA) for a national, tax assistance non-profit that has
              been used by thousands of low-income taxpayers to determine their
              eligibility for exemption from the ACA coverage requirement
            </li>
          </ul>
        </div>
        <div>
          <hgroup>
            <h1>
              aggbuzz / mecha <span>/</span> <span>Co-creator</span>
            </h1>
            <h2>September 2015 - July 2018, Birmingham, AL</h2>
          </hgroup>
          <ul>
            <li>
              Designed and developed a{" "}
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://aggbuzz.com"
              >
                video platform
              </a>{" "}
              (React, Redux, NodeJS, Neo4j and Redis) with a time-synced
              commenting system - like VH1’s <em>Pop-Up Video</em> for YouTube
            </li>
            <li>
              Created curated software conference{" "}
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://mecha.video/"
              >
                video platform
              </a>{" "}
              (React, Redux, styled-components, Google Firestore, hosted on
              Google Cloud)
            </li>
          </ul>
        </div>
      </section>
      <section>
        <h1>Education</h1>
        <div>
          <hgroup>
            <h1>
              Vanderbilt University <span>/</span>{" "}
              <span>BA, Double Major in Economics and Philosophy</span>
            </h1>
            <h2>August 2005 - May 2009, Nashville, TN</h2>
          </hgroup>
        </div>
      </section>
      <section>
        <h1>Hobbies and Interests</h1>
        <div>
          <ul>
            <li>Guitar, hiking, live music, travel</li>
          </ul>
        </div>
      </section>
    </div>
  </main>
);

export default Resume;



// WEBPACK FOOTER //
// ./src/pages/Resume.js